import Vue from 'vue';
import response from "vue-resource/src/http/response";

const DATE_3_MONTH = 86400 * 91 * 1000;
const LIMIT_DATE = 5;
const HOME_VIDEO_GROUP = 10;
const PUBLIC_VIDEO_GROUP = 320;
const PRIVATE_VIDEO_GROUP = 65;
const CSC_ENABLED = true; // обращения в абонентский отдел из личного кабинета

const state = {
    contract: '',
    contractStatus: 0,
    contractStatusTitle: '',
    contractLimit: 0,
    contractMaxLimit: 0,
    contractLimitCount: 0,
    personalInfo: '',
    fio: '',
    address: '',
    password: '',
    contractId: '',
    balance: '',
    tariffs: [],
    phone: '',
    phones: [],
    question: '',
    email: '',
    cameras: [],
    cameraUrl: null,
    cameraArchiveUrl: null,
    interview: null,
    loginDialogVisible: false,
    cityDialogVisible: false,
    checkAddressDialogVisible: false,
    appealDialogVisible: false,
    emailDialogVisible: false,
    emailSendDialogVisible: false,
    phoneDialogVisible: false,
    needCheckUserPhone: false,
    city: {
        value: 1,
        text: 'Новокузнецк',
        phone: '756060',
        code: '3843',
        support_phone: '756000'
    },
    statuses: {
        0: { text: 'активен', color: 'light-green lighten-1' },
        2: { text: 'отключен', color: 'amber lighten-1' },
        4: { text: 'приостановлен', color: 'amber lighten-1' },
        6: { text: 'заблокирован', color: 'amber lighten-1' },
        3: { text: 'закрыт', color: 'red lighten-2' },
    },
    cities: [
        { text: 'Новокузнецк', value: 1, phone: '756060', code: '3843', support_phone: '756000' },
        { text: 'Осинники', value: 2, phone: '51399', code: '38471', support_phone: '51399' }
        //{text: 'Осинники', value: 2, phone: '44189', code: '38471', support_phone: '44189'}
    ],
    claims: [],
    claimStatus: {
        2: 'Ждет выполнения',
        3: 'Выполняется',
        5: 'Проверка выполненния',
        8: 'Завершена'
    },
    accessToken: '',
    streams: [],
    remember: false,
    cameraTimer: null,
    sendSmsCode: false,
    cscClaims: [],
    cscEnabled: CSC_ENABLED,
    iviPossibility: false,
    iviAuthenticated: false,
    iviSubscriptionDialogVisible: false,
    smkaPossibility: false,
    smkaAuthenticated: false,
    smkaSubscriptionDialogVisible: false,
};

const mutations = {
    changeUserParams(state, items) {
        state = Object.assign(state, items)
    },
    setUserBlank(state) {
        state.contract = '';
        state.password = '';
        state.fio = '';
        state.contractStatus = 0;
        state.contractLimit = 0;
        state.contractMaxLimit = 0;
        state.contractLimitCount = 0;
        state.personalInfo = '';
        state.contractId = '';
        state.balance = '';
        state.tariffs = [];
        state.phone = '';
        state.phones = [];
        state.email = '';
        state.address = '';
        state.interview = null;
        state.cameraUrl = null;
        state.tariffs = [];
        state.claims = [];
        state.remember = false;
        state.cameras = [];
        clearInterval(state.cameraTimer);
        state.cameraTimer = null;
    },
    setUser(state, contract) {
        state.contract = contract.title;
        state.password = contract.password;
        state.fio = contract.fio;
        state.address = contract.street + ' д.' + contract.house + ' кв.' + contract.flat;
        state.contractStatusTitle = contract.status_title;
        state.contractStatus = Number.parseInt(contract.status);
        state.contractLimit = Number.parseInt(contract.limit_summa);
        state.contractMaxLimit = Number.parseInt(contract.max_limit_summa);
        state.contractLimitCount = Number.parseInt(contract.limit_count);
        state.personalInfo = contract.personal_info;
        state.contractId = Number.parseInt(contract.id);
        state.balance = contract.balance;
        if (contract.phones !== undefined)
            state.phone = contract.phones[0] !== undefined ? contract.phones[0].replace(/(<|>)+/g, '').trim() : '';
        state.phones = contract.phones;
        if (contract.emails !== undefined)
            state.email = contract.emails[0] !== undefined ? contract.emails[0].replace(/(<|>)+/g, '').trim() : '';
        state.cities.forEach(city => {
            if (city.text === contract.city)
                state.city = city;
        });
        state.accessToken = contract.access_token;
        // state.tariffs = contract.tariffs;
        // данные по тарифам получаем из setUserTariffs
        state.tariffs = [];
    },
};

const getters = {
    getUserContractTitle: state => state.contract,
    getUserContractFio: state => state.fio,
    getUserContractShortFio: state => {
        if (state.fio === '')
            return '';
        let fio = state.fio.split(" ");
        if (fio[0] === undefined || fio[1] === undefined || fio[2] === undefined)
            return '';
        return fio[0] + ' ' + fio[1].substr(0, 1) + '.' + fio[2].substr(0, 1) + '.';
    },
    getUserContractAddress: state => state.address,
    getUserContractStatusTitle: state => state.contractStatusTitle,
    getUserContractStatus: state => state.contractStatus,
    getUserContractLimit: state => state.contractLimit,
    getUserContractMaxLimit: state => state.contractMaxLimit,
    getUserContractPersonalInfo: state => state.personalInfo,
    getUserContractPhone: state => state.phone,
    getUserQuestion: state => state.question,
    getUserContractEmail: state => state.email,
    getUserPassword: state => state.password,
    getUserPhones: state => state.phones,
    getUserPhone: state => state.phone,
    getUserContractId: state => state.contractId,
    getUserTariffs: state => state.tariffs,
    getUserBalance: state => state.balance || 0,
    getUserBalanceTrunc: state => {
        let temp = Math.trunc(state.balance || 0);
        return 1 / temp < 0 ? '-' + Math.abs(temp).toString() : temp.toString();
    },
    getUserBalanceFraction: state => {
        let balance = Math.abs(state.balance || 0);
        let str = balance.toString();
        let zeroPos = str.indexOf(".");

        if (-1 === zeroPos) {
            return "";
        }
        return str.slice(zeroPos + 1).substr(0, 2);
    },
    getUserLoginDialogVisible: state => state.loginDialogVisible,
    getUserEmailDialogVisible: state => state.emailDialogVisible,
    getUserEmailSendDialogVisible: state => state.emailSendDialogVisible,
    getUserPhoneDialogVisible: state => state.phoneDialogVisible,
    getCheckUserPhoneDialogVisible: state => state.needCheckUserPhone,
    // getUserTariffsFiltered: state => state.tariffs.filter(tariff => {
    //     return tariff.visible
    // }),
    getUserTariffsFiltered: state => state.tariffs.map(tariff => {
        if (tariff.speed)
            tariff.internet_service = tariff.speed;
        return tariff
    }),
    getUserInternetTariffs: state => state.tariffs.filter(tariff => {
        return /(Инет|Кросс)/.test(tariff)
    }),
    getUserCity: state => state.city,
    getUserOfficePhone: state => (full) => {
        let phone = full ? '+7' + ' (' + state.city.code + ') ' : '';
        if (state.city.code.length === 4)
            phone += state.city.phone.substr(0, 2) + '-' + state.city.phone.substr(2, 2) + '-' + state.city.phone.substr(4, 2);
        else if (state.city.code.length === 5)
            phone += state.city.phone.substr(0, 1) + '-' + state.city.phone.substr(1, 2) + '-' + state.city.phone.substr(3, 2);
        return phone;
    },
    getUserSupportPhone: state => (full) => {
        let phone = full ? '+7' + ' (' + state.city.code + ') ' : '';
        if (state.city.code.length === 4)
            phone += state.city.support_phone.substr(0, 2) + '-' + state.city.support_phone.substr(2, 2) + '-' + state.city.support_phone.substr(4, 2);
        else if (state.city.code.length === 5)
            phone += state.city.support_phone.substr(0, 1) + '-' + state.city.support_phone.substr(1, 2) + '-' + state.city.support_phone.substr(3, 2);
        return phone;
    },
    getUserCities: state => state.cities,
    getUserCityDialogVisible: state => state.cityDialogVisible,
    getUserCheckAddressDialogVisible: state => state.checkAddressDialogVisible,
    getUserAppealDialogVisible: state => state.appealDialogVisible,
    getUserClaims: state => state.claims,
    getUserStatusParams: state => state.statuses[state.contractStatus] !== undefined ? state.statuses[state.contractStatus] : 'grey',
    getUserClaimStatus: state => state.claimStatus,
    getUserStreams: state => state.streams,
    getUserRemember: state => state.remember,
    getUserContractLimitCount: state => state.contractLimitCount,
    getUserInterview: state => state.interview,
    getUserCameras: state => state.cameras,
    getUserHomeCameras: state => {
        return state.cameras.filter(item => {
            if (item.ParentID !== null)
                return item;
        });
    },
    getUserPublicCameras: state => {
        return state.cameras.filter(item => {
            if (false)
                return item;
        })
    },
    getUserPrivateCameras: state => {
        return state.cameras.filter(item => {
            if (item.ParentID === null)
                return item;
        })
    },
    getUserCameraUrl: state => state.cameraUrl,
    getUserCameraArchiveUrl: state => state.cameraArchiveUrl,
    getUserCameraTimer: state => state.cameraTimer,
    getUserSendCode: state => state.sendSmsCode,
    getCscClaims: state => state.cscClaims,
    getCscEnabled: state => state.cscEnabled,
    getIviPossibility: state => state.iviPossibility,
    getIviAuthenticated: state => state.iviAuthenticated,
    getIviDialogVisible: state => state.iviSubscriptionDialogVisible,
    getSmkaPossibility: state => state.smkaPossibility,
    getSmkaAuthenticated: state => state.smkaAuthenticated,
    getSmkaDialogVisible: state => state.smkaSubscriptionDialogVisible,
};

const actions = {
    changeUser({ commit }, items) {
        commit('changeUserParams', items);
    },
    changeUserCity({ commit }, city) {
        commit('changeUserParams', { city: city });
    },
    setUserIpAuth({ commit }) {
        commit('createProcess', 'userIp');
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/ip').then(response => {
            if (response.data.length !== 0) {
                let contract = response.data;
                commit('setUser', contract);
                commit('setProcessSuccess', 'userIp');
            } else {
                commit('setProcessFailed', { id: 'userIp', message: 'Пользователь не найден.' });
            }
        }, response => {
            commit('setUserBlank');
            commit('setProcessFailed', { id: 'userIp', message: response.body.message });
        });
    },
    setUserRecoveryIpAuth({ commit }) {
        commit('createProcess', 'userRecoveryIp');
        Vue.http.get(this.getters.getApiUrl + 'v1/access-recovery').then(response => {
            if (response.data.length !== 0) {
                let contract = response.data;
                commit('setUser', contract);
                commit('setProcessSuccess', 'userRecoveryIp');
            } else {
                commit('setProcessFailed', { id: 'userRecoveryIp', message: 'Пользователь не найден.' });
            }
        }, response => {
            commit('setUserBlank');
            commit('setProcessFailed', { id: 'userRecoveryIp', message: response.body.message });
        });
    },
    setUserLoginAuth({ commit }, params) {
        commit('createProcess', 'userLogin');
        let item = {
            'login': state.contract,
            'password': state.password,
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/login', item).then(response => {
            if (response.data.length === 0) {
                commit('setProcessFailed', { id: 'userLogin', message: 'Договор или пароль указан неверно.' });
            } else {
                let contract = response.data;
                commit('setUser', contract);
                commit('setProcessSuccess', 'userLogin');
                if (params.redirect)
                    params.router.push("/cabinet");
            }
        }, response => {
            commit('setProcessFailed', { id: 'userLogin', message: response.body.message });
        });
    },
    setUserCodeAuth({ commit }, code) {
        commit('createProcess', 'userCodeLogin');
        let item = {
            'code': code,
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/check-code', item).then(response => {
            if (response.data.length === 0) {
                commit('setProcessFailed', { id: 'userCodeLogin', message: 'Код указан.' });
            } else {
                let contract = response.data;
                commit('setUser', contract);
                commit('setProcessSuccess', 'userCodeLogin');
            }
        }, response => {
            commit('setProcessFailed', { id: 'userCodeLogin', message: response.body.message });
        });
    },
    setUserLogout({ commit }) {
        commit('setUserBlank');
        commit('changeConnectParams', { phone: '' });
        commit('destroyProcess', 'userLogin');
        commit('destroyProcess', 'getUserTariffs');
        commit('destroyProcess', 'getUserClaims');
        commit('destroyProcess', 'userInterview');
        commit('destroyProcess', 'userCameras');
    },
    setUserStreams({ commit }) {
        commit('createProcess', 'userStreams');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/streams?access-token=' + state.accessToken).then(response => {
            commit('changeUserParams', { streams: response.data });
            commit('setProcessSuccess', 'userStreams');
        }, response => {
            commit('setProcessFailed', { id: 'userStreams', message: response.body.message });
        });
    },
    setUserLimit({ commit }) {
        commit('createProcess', 'userLimit');
        let limit = Math.floor(Math.min(state.balance - state.contractMaxLimit, -1));
        let params = {
            summa: limit,
            days: LIMIT_DATE,
        };
        commit('changeUserParams', {
            contractLimit: limit
        });
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/limit?access-token=' + state.accessToken, params).then(response => {
            commit('changeUserParams', {
                contractLimit: response.data.summa,
                contractStatus: 0,
                contractStatusTitle: 'Активен'
            });
            commit('setProcessSuccess', 'userLimit');
        }, response => {
            commit('setProcessFailed', { id: 'userLimit', message: response.body.message });
        });
    },
    setUserInterview({ commit }) {
        commit('createProcess', 'userInterview');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/interview?access-token=' + state.accessToken).then(response => {
            if (response.data.id !== undefined)
                commit('changeUserParams', { interview: response.data });
            commit('setProcessSuccess', 'userInterview');
        }, response => {
            commit('setProcessFailed', { id: 'userInterview', message: response.body.message });
        });
    },
    setUserPhone({ commit }) {
        let params = {
            phone: state.phone,
        };
        commit('createProcess', 'userPhone');
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/phone?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userPhone');
            commit('changeConnectParams', { phone: state.phone });
        }, response => {
            commit('setProcessFailed', { id: 'userPhone', message: response.body.message });
        });
    },
    setUserCodePhone({ commit }, code) {
        commit('createProcess', 'userCodePhone');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/check-phone?access-token=' + state.accessToken + '&code=' + code).then(response => {
            commit('setProcessSuccess', 'userCodePhone');
            commit('changeUserParams', { phoneDialogVisible: false });
            commit('changeUserParams', { needCheckUserPhone: 0 });
        }, response => {
            commit('setProcessFailed', { id: 'userCodePhone', message: response.body.message });
        });
    },
    needCheckUserPhone({ commit }) {
        commit('createProcess', 'checkUserPhone');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/need-check-phone?access-token=' + state.accessToken).then(response => {
            commit('setProcessSuccess', 'checkUserPhone');
            if (false === state.emailDialogVisible) {
                commit('changeUserParams', { needCheckUserPhone: 1 === response.data });
            }
        }, response => {
            commit('setProcessFailed', { id: 'checkUserPhone', message: response.body.message });
        });
    },
    setUserEmail({ commit }) {
        let params = {
            email: state.email.replace(/\s+/, ""),
        };
        commit('createProcess', 'userEmail');
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/email?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userEmail');
        }, response => {
            commit('setProcessFailed', { id: 'userEmail', message: response.body.message });
        });
    },
    setUserCameras({ commit }) {
        commit('createProcess', 'userCameras');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/cameras?access-token=' + state.accessToken).then(response => {
            commit('setProcessSuccess', 'userCameras');
            commit('changeUserParams', { cameras: response.data });
        }, response => {
            commit('setProcessFailed', { id: 'userCameras', message: response.body.message });
        });
    },
    setUserPhones({ commit }) {
        commit('createProcess', 'userPhones');
        let params = {
            'title': state.contract
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/phone-by-title', params).then(response => {
            commit('setProcessSuccess', 'userPhones');
            commit('changeUserParams', {
                phones: response.data.phones,
                contractId: response.data.id
            });
        }, response => {
            commit('setProcessFailed', { id: 'userPhones', message: response.body.message });
        });
    },
    setUserCode({ commit, getters }, index) {
        commit('createProcess', 'userCode');
        commit('changeUserParams', {
            sendSmsCode: false
        });
        let params = {
            'index': index,
            'contract_id': getters.getUserContractId
        };
        console.log(params);
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/send-code', params).then(response => {
            commit('setProcessSuccess', 'userCode');
            commit('changeUserParams', { sendSmsCode: true });
        }, response => {
            commit('setProcessFailed', { id: 'userCode', message: response.body.message });
        });
    },
    setUserPassword({ commit }, password) {
        commit('createProcess', 'userPassword');
        let params = {
            'password': password
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/password-update?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userPassword');
            commit('changeUserParams', { password: response.data.password });
        }, response => {
            commit('setProcessFailed', { id: 'userPassword', message: response.body.message });
        });
    },
    updateUserCameras({ commit }) {
        commit('createProcess', 'userUpdateCameras');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/cameras?access-token=' + state.accessToken).then(response => {
            commit('setProcessSuccess', 'userUpdateCameras');
            let oldCameras = state.cameras;
            response.data.forEach(item => {
                state.cameras.forEach(camera => {
                    if (camera.CameraID === item.CameraID)
                        camera = item;
                })
            })
        }, response => {
            commit('setProcessFailed', { id: 'userUpdateCameras', message: response.body.message });
        });
    },
    setUserCamera({ commit }, id) {
        commit('createProcess', 'userCamera');
        let params = {
            'id': id
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/camera?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userCamera');
            commit('changeUserParams', { cameraUrl: response.data.URL });
        }, response => {
            commit('setProcessFailed', { id: 'userCamera', message: response.body.message, code: response.status });
        });
    },
    setUserCameraArchive({ commit }, id) {
        commit('createProcess', 'userCameraArchive');
        let params = {
            'camera_id': id
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/camera-archive?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userCameraArchive');
            commit('changeUserParams', { cameraArchiveUrl: response.data.Url });
        }, response => {
            commit('setProcessFailed', { id: 'userCameraArchive', message: response.body.message });
        });
    },
    sendUserAppeal({ commit }) {
        commit('createProcess', 'appeal');
        let items = {
            phone: state.phone,
            fio: state.fio,
            text: state.question,
        };
        if (state.email !== '')
            items.email = state.email;
        if (state.contract !== '') {
            items.contract = state.contract;
            items.contractId = state.contractId;
        }
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/appeal', items).then(response => {
            commit('setProcessSuccess', 'appeal');
        }, response => {
            commit('setProcessFailed', { id: 'appeal', message: response.body.message });
        });
    },
    sendUserBalanceDetail({ commit }, params) {
        commit('createProcess', 'sendUserBalance');
        let dateParameter = params.dateTo.split("-");
        let dateLast = new Date(parseInt(dateParameter[0]), parseInt(dateParameter[1]), 0);
        let item = {
            'date_from': params.dateFrom + '-01',
            'date_to': params.dateTo + '-' + dateLast.getDate(),
        };
        let url = this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/balance-detail?access-token=' + state.accessToken;
        Vue.http.post(url, item).then(response => {
            commit('setProcessSuccess', 'sendUserBalance');
        }, response => {
            commit('setProcessFailed', { id: 'sendUserBalance', message: response.body.message, code: response.status });
        });
    },
    setUserBalance({ commit }) {
        commit('createProcess', 'getUserBalance');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/balance?access-token=' + state.accessToken).then(response => {
            if (response.data.length === 0)
                return false;
            commit('changeUserParams', { balance: response.data.balance });
            commit('setProcessSuccess', 'getUserBalance');
        }, response => {
            commit('setProcessFailed', { id: 'getUserBalance', message: response.body.message, code: response.status });
        });
    },
    setUserClaims({ commit }) {
        commit('createProcess', 'getUserClaims');
        let dateFrom = new Date();
        dateFrom.setTime((new Date().getTime() - (DATE_3_MONTH)));
        let dateTo = new Date();
        let url = this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/claims?access-token=' + state.accessToken
            + '&date_from=' + dateFrom.toISOString().substr(0, 10) + '&date_to=' + dateTo.toISOString().substr(0, 10);
        Vue.http.get(url).then(response => {
            commit('changeUserParams', { claims: response.data.claims });
            commit('setProcessSuccess', 'getUserClaims');
        }, response => {
            commit('setProcessFailed', { id: 'getUserClaims', message: response.body.message });
        });
    },
    setUserTariffs({ commit }) {
        commit('createProcess', 'getUserTariffs');
        Vue.http.get(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/tariffs-groups?access-token=' + state.accessToken).then(response => {
            if (response.data.length === 0)
                return false;
            commit('changeUserParams', { tariffs: response.data });
            commit('setProcessSuccess', 'getUserTariffs');
        }, response => {
            commit('setProcessFailed', { id: 'getUserTariffs', message: response.body.message, code: response.status });
        });
    },
    setUserRemoteService({ commit }) {
        commit('createProcess', 'userRemoteService');
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/remote-service?access-token=' + state.accessToken).then(response => {
            commit('setProcessSuccess', 'userRemoteService');
        }, response => {
            commit('setProcessFailed', { id: 'userRemoteService', message: response.body.message });
        });
    },
    setUserContractTitle({ commit }, value) {
        commit('changeUserParams', { contract: value });
    },
    setUserPasswordValue({ commit }, value) {
        commit('changeUserParams', { password: value });
    },
    setUserRemember({ commit }, value) {
        commit('changeUserParams', { remember: value });
    },
    setUserRateAnswer({ commit }, params) {
        commit('createProcess', 'userRate');
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/' + state.contractId + '/rate?access-token=' + state.accessToken, params).then(response => {
            commit('setProcessSuccess', 'userRate');
            let inteview = state.interview;
            inteview.answer = params.answer_id;
            commit('changeUserParams', { interview: inteview });
        }, response => {
            commit('setProcessFailed', { id: 'userRate', message: response.body.message });
        });
    },
    setUserCameraTimer({ commit }, value) {
        commit('changeUserParams', { cameraTimer: value });
    },
    setUserPhoneItem({ commit }, value) {
        commit('changeUserParams', { phone: value });
    },
    clearUserArchiveUrl({ commit }) {
        commit('changeUserParams', { cameraArchiveUrl: null });
    },
    setCscClaims({ commit }) {
        Vue.http.get(this.getters.getApiUrl + 'v1/claim/reasons').then(response => {
            let keys = Object.keys(response.data);
            if (keys.length > 0) {
                let claims = [];
                keys.forEach(key => {
                    let val = response.data[key];
                    if (key != 110) {
                        claims.push({ id: key, title: val });
                    }
                });
                state.cscClaims = claims;
            }
        });
    },
    makeCscClaim({ commit }, params) {
        Vue.http.get(this.getters.getApiUrl +
            'v1/claim/new?reason=' + params.reason +
            '&phone=' + params.phone +
            '&id=' + state.contractId +
            '&access_token=' + state.accessToken).then(response => {

                console.log(response);
            });
    },
    setIviData({ commit }) {
        Vue.http.get(this.getters.getApiUrl +
            'v1/ivi/' + state.contractId + '/details?access-token=' + state.accessToken).then(response => {
                state.iviAuthenticated = response.data.is_auth;
                state.iviPossibility = response.data.possibility;
            });
    },
    sendIviPhone({ commit }, params) {
        Vue.http.post(this.getters.getApiUrl +
            'v1/ivi/' + state.contractId + '/phone/add?access-token=' + state.accessToken + '&phone=' + params.phone).then(response => {
                params.result(true);
            }, response => {
                params.result(false, response.body.message);
            });
    },
    sendIviCode({ commit }, params) {
        Vue.http.post(this.getters.getApiUrl +
            'v1/ivi/' + state.contractId + '/phone/check?access-token=' + state.accessToken + '&code=' + params.code).then(response => {
                params.result(true);
            }, response => {
                params.result(false, response.body.message);
            });
    },
    checkContractToken({ commit }, params) {
        Vue.http.get(this.getters.getApiUrl +
            'v1/contracts/check-token?token=' + params.token).then(response => {
                if (params.result) {
                    let success = response.body.success;
                    if (success)
                        params.result(success, response.body.data);
                    else
                        params.result(success);
                }
            }, response => {
                if (params.result) params.result(false);
            });
    },
    setEmailByToken({ commit }, params) {
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/set-email-by-token', params.data)
            .then(response => {
                if (params.result) params.result(true);
            }, fail => {
                if (params.result) params.result(false, fail.body.message);
            });
    },
    setUserCities({ commit }, citiesData) {
        state.cities = citiesData;
    },
    setSmkaData({ commit }) {
        Vue.http.get(this.getters.getApiUrl +
            'v1/smka/' + state.contractId + '/details?access-token=' + state.accessToken).then(response => {
                state.smkaAuthenticated = response.data.is_auth;
                state.smkaPossibility = response.data.possibility;
            })
    },
    sendSmkaCredentials({ commit }, params) {
        Vue.http.post(this.getters.getApiUrl +
            'v1/smka/' + state.contractId + '/send/credentials?access-token=' + state.accessToken + '&phone=' + params.phone).then(response => {
                if (params.result) params.result(true);
            }, response => {
                if (params.result) params.result(false, response.body.message);
            })
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js